<template>
    <div v-if="isShow">
        <sd-mask>
            <div class="message-box">
                <div class="content">
                    <div class="title">{{info.title}}</div>
                    <div class="text">
                        <template v-if="info.text">{{info.text}}</template>
                        <slot></slot>
                    </div>
                    
                </div>
                <div class="footer">
                    <template v-if="showCancel == ''">
                        <div class="button" @click="$emit('cancel')">{{info.cancelText || $t('text.cancel')}}</div>
                        <div class="line"></div>
                    </template>
                    <div class="button" @click="$emit('confirm')">{{info.confirmText || $t('text.confirm')}}</div>
                </div>
            </div>
        </sd-mask>
    </div>
</template>

<script>
import sdMask from './mask.vue';

export default {
    name: "sd-message-box",
    components: { sdMask },
    props: {
        info: Object,
        showCancel: String,
    },
    computed: {
        isShow() {
            return this.info.show;
        }
    }
}
</script>

<style lang="scss" scoped>
.message-box {
    background: white;
    width: 308px;
    margin: auto;
    margin-top: 228px;
    border-radius: 4px;

    .content {
        .title {
            font-size: 20px;
            line-height: 28px;
            padding: 18px 0 11px;
            font-weight: bold;
        }

        .text {
            text-align: left;
            line-height: 22px;
            color: #7B828F;
            padding: 0 25px;
            min-height: 66px;
            margin-bottom: 9px;
            white-space: pre-wrap;
        }
    }

    .footer {
        display: flex;
        align-items: center;
        border-top: 1px solid rgba(0, 0, 0, 0.05);

        .button {
            flex: 1;
            line-height: 48px;
            color: #E22F25;
            font-weight: bold;
        }

        .line {
            width: 1px;
            height: 24px;
            background-color: rgba(0, 0, 0, 0.05);
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/message.vue